import React from "react";

const TextField = ({ value, onChange, placeholder, required, readOnly }) => {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || ""}
      required={required}
      readOnly={readOnly}
      className="text-field"
    />
  );
};

export default TextField;
